import { HTMLProps, ReactNode } from 'react';
import { cn } from '../../utils/common-utils';

type IQuizQuestion = {
  actionsRow?: ReactNode;
  collapsedPrompt?: ReactNode;
  isCollapsed?: boolean;
  questionName: ReactNode;
  number?: number;
  onInsertQuestion?: () => void;
  onChangeQuestion?: () => void;
  onRemoveQuestion?: () => void;
  onClickQuestion: () => void;
} & HTMLProps<HTMLDivElement>;

const QuizQuestion = ({
  actionsRow,
  collapsedPrompt,
  isCollapsed = false,
  number,
  questionName,
  onInsertQuestion,
  onChangeQuestion,
  onRemoveQuestion,
  onClickQuestion,
  children,
  ...props
}: IQuizQuestion) => {
  const { className, ...restProps } = props;
  const renderActionButtons = () => {
    if (!onInsertQuestion && !onChangeQuestion && !onRemoveQuestion) {
      return null;
    }

    return (
      <div className={'flex w-[5.75rem] shrink-0 flex-col items-end gap-0.5 text-right'}>
        {onInsertQuestion && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onInsertQuestion();
            }}
            className={
              'rounded px-1.5 py-0.5 text-xs font-medium leading-none text-blue hover:underline'
            }
          >
            Insert Above
          </button>
        )}

        {onChangeQuestion && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onChangeQuestion();
            }}
            className={
              'rounded px-1.5 py-0.5 text-xs font-medium leading-none text-blue hover:underline'
            }
          >
            Change
          </button>
        )}

        {onRemoveQuestion && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemoveQuestion();
            }}
            className={
              'rounded px-1.5 py-0.5 text-xs font-medium leading-none text-[#F05252] hover:underline'
            }
          >
            Delete
          </button>
        )}
      </div>
    );
  };

  return (
    <div
      className={cn(
        'border border-table-border bg-[#FAFAFA] px-2 py-1 text-sm font-normal text-black hover:cursor-pointer hover:bg-light-blue',
        className,
      )}
      onClick={onClickQuestion}
      {...restProps}
    >
      {isCollapsed ? (
        <div className={'flex w-full items-start gap-1.5'}>
          <div className={'flex min-w-0 flex-1 flex-col gap-1'}>
            <div className={'flex min-w-0 flex-1 items-center gap-1.5'}>
              {typeof number === 'number' && (
                <span className={'block w-8 shrink-0 leading-tight'}>{number}.</span>
              )}
              <div className={'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap leading-tight text-black'}>
                {questionName}
              </div>
            </div>

            <div className={'flex min-w-0 flex-1 items-center gap-1.5'}>
              <div className={'shrink-0'}>{actionsRow}</div>
              <div
                className={
                  'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap leading-tight text-black'
                }
              >
                {collapsedPrompt}
              </div>
            </div>
          </div>

          {renderActionButtons()}
        </div>
      ) : (
        <div className={'flex w-full flex-col gap-1'}>
          <div className={'flex w-full items-start justify-between gap-1.5'}>
            {children}

            <div className={'flex min-w-0 flex-1 items-center gap-1.5'}>
              {typeof number === 'number' && (
                <span className={'block w-8 shrink-0 leading-tight'}>{number}.</span>
              )}
              <div className={'min-w-0 flex-1 leading-tight'}>
                {questionName}
              </div>
            </div>

            {renderActionButtons()}
          </div>
        </div>
      )}
    </div>
  );
};
export default QuizQuestion;
